"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductTypes = void 0;
const ProductTypes = exports.ProductTypes = {
  LIQUOR: "LIQUOR",
  WINE: "WINE",
  BEER: "BEER",
  NA: "N/A"
};